import { createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  id: "kt_aside_menu_wrapper",
  ref: "scrollElRef",
  class: "hover-scroll-overlay-y my-5 my-lg-5",
  "data-kt-scroll": "true",
  "data-kt-scroll-activate": "{default: false, lg: true}",
  "data-kt-scroll-dependencies": "#kt_aside_logo, #kt_aside_footer",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-offset": "0",
  "data-kt-scroll-wrappers": "#kt_aside_menu"
}
const _hoisted_2 = {
  id: "#kt_header_menu",
  class: "menu menu-column menu-title-gray-800 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500",
  "data-kt-menu": "true"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("h1", { class: " m-0 text-white fw-bolder fs-3" }, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_5 = { class: "menu-content pt-8 pb-2" }
const _hoisted_6 = { class: "menu-section text-muted text-uppercase fs-8 ls-1" }
const _hoisted_7 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_8 = {
  key: 0,
  class: "menu-icon"
}
const _hoisted_9 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_10 = { class: "menu-title" }
const _hoisted_11 = { class: "menu-link" }
const _hoisted_12 = {
  key: 0,
  class: "menu-icon"
}
const _hoisted_13 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_14 = { class: "menu-title" }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "menu-arrow" }, null, -1)
const _hoisted_16 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_18 = { class: "menu-title" }
const _hoisted_19 = { class: "menu-link" }
const _hoisted_20 = /*#__PURE__*/_createVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_21 = { class: "menu-title" }
const _hoisted_22 = /*#__PURE__*/_createVNode("span", { class: "menu-arrow" }, null, -1)
const _hoisted_23 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_24 = /*#__PURE__*/_createVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_25 = { class: "menu-title" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "menu-item" }, [
  /*#__PURE__*/_createVNode("div", { class: "menu-content" }, [
    /*#__PURE__*/_createVNode("div", { class: "separator mx-1 my-4" })
  ])
], -1)
const _hoisted_27 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_28 = { class: "menu-content pt-8 pb-2" }
const _hoisted_29 = { class: "menu-section text-muted text-uppercase fs-8 ls-1" }
const _hoisted_30 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_31 = {
  key: 0,
  class: "menu-icon"
}
const _hoisted_32 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_33 = { class: "menu-title" }
const _hoisted_34 = { class: "menu-link" }
const _hoisted_35 = {
  key: 0,
  class: "menu-icon"
}
const _hoisted_36 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_37 = { class: "menu-title" }
const _hoisted_38 = /*#__PURE__*/_createVNode("span", { class: "menu-arrow" }, null, -1)
const _hoisted_39 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_40 = /*#__PURE__*/_createVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_41 = { class: "menu-title" }
const _hoisted_42 = { class: "menu-link" }
const _hoisted_43 = /*#__PURE__*/_createVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_44 = { class: "menu-title" }
const _hoisted_45 = /*#__PURE__*/_createVNode("span", { class: "menu-arrow" }, null, -1)
const _hoisted_46 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_47 = /*#__PURE__*/_createVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createVNode("span", { class: "bullet bullet-dot" })
], -1)
const _hoisted_48 = { class: "menu-title" }
const _hoisted_49 = /*#__PURE__*/_createVNode("div", { class: "menu-item" }, [
  /*#__PURE__*/_createVNode("div", { class: "menu-content" }, [
    /*#__PURE__*/_createVNode("div", { class: "separator mx-1 my-4" })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _withDirectives(_createVNode("div", null, [
        _hoisted_3
      ], 512), [
        [_vShow, _ctx.isAdmin == 'Admin']
      ]),
      (_ctx.isAdmin == 'Admin')
        ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.AdminMenuConfig, (item, i) => {
            return (_openBlock(), _createBlock(_Fragment, { key: i }, [
              (item.heading)
                ? (_openBlock(), _createBlock("div", _hoisted_4, [
                    _createVNode("div", _hoisted_5, [
                      _createVNode("span", _hoisted_6, _toDisplayString(_ctx.translate(item.heading)), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.pages, (menuItem, j) => {
                return (_openBlock(), _createBlock(_Fragment, { key: j }, [
                  (menuItem.heading)
                    ? (_openBlock(), _createBlock("div", _hoisted_7, [
                        _createVNode(_component_router_link, {
                          to: menuItem.route
                        }, {
                          default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                            _createVNode("a", {
                              class: [[isActive && 'active', isExactActive && 'active'], "menu-link"],
                              href: href,
                              onClick: navigate
                            }, [
                              (menuItem.svgIcon || menuItem.fontIcon)
                                ? (_openBlock(), _createBlock("span", _hoisted_8, [
                                    (_ctx.asideMenuIcons === 'font')
                                      ? (_openBlock(), _createBlock("i", {
                                          key: 0,
                                          class: [menuItem.fontIcon, "bi fs-3"]
                                        }, null, 2))
                                      : (_ctx.asideMenuIcons === 'svg')
                                        ? (_openBlock(), _createBlock("span", _hoisted_9, [
                                            _createVNode(_component_inline_svg, {
                                              src: menuItem.svgIcon
                                            }, null, 8, ["src"])
                                          ]))
                                        : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("span", _hoisted_10, _toDisplayString(_ctx.translate(menuItem.heading)), 1)
                            ], 10, ["href", "onClick"])
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    : _createCommentVNode("", true),
                  (menuItem.sectionTitle)
                    ? (_openBlock(), _createBlock("div", {
                        key: 1,
                        class: [{ show: _ctx.hasActiveChildren(menuItem.route) }, "menu-item menu-accordion"],
                        "data-kt-menu-sub": "accordion",
                        "data-kt-menu-trigger": "click"
                      }, [
                        _createVNode("span", _hoisted_11, [
                          (menuItem.svgIcon || menuItem.fontIcon)
                            ? (_openBlock(), _createBlock("span", _hoisted_12, [
                                (_ctx.asideMenuIcons === 'font')
                                  ? (_openBlock(), _createBlock("i", {
                                      key: 0,
                                      class: [menuItem.fontIcon, "bi fs-3"]
                                    }, null, 2))
                                  : (_ctx.asideMenuIcons === 'svg')
                                    ? (_openBlock(), _createBlock("span", _hoisted_13, [
                                        _createVNode(_component_inline_svg, {
                                          src: menuItem.svgIcon
                                        }, null, 8, ["src"])
                                      ]))
                                    : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode("span", _hoisted_14, _toDisplayString(_ctx.translate(menuItem.sectionTitle)), 1),
                          _hoisted_15
                        ]),
                        _createVNode("div", {
                          class: [{ show: _ctx.hasActiveChildren(menuItem.route) }, "menu-sub menu-sub-accordion"]
                        }, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(menuItem.sub, (item2, k) => {
                            return (_openBlock(), _createBlock(_Fragment, { key: k }, [
                              (item2.heading)
                                ? (_openBlock(), _createBlock("div", _hoisted_16, [
                                    _createVNode(_component_router_link, {
                                      to: item2.route
                                    }, {
                                      default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                                        _createVNode("a", {
                                          class: [[
                          isActive && 'active',
                          isExactActive && 'active'
                        ], "menu-link"],
                                          href: href,
                                          onClick: navigate
                                        }, [
                                          _hoisted_17,
                                          _createVNode("span", _hoisted_18, _toDisplayString(_ctx.translate(item2.heading)), 1)
                                        ], 10, ["href", "onClick"])
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                : _createCommentVNode("", true),
                              (item2.sectionTitle)
                                ? (_openBlock(), _createBlock("div", {
                                    key: 1,
                                    class: [{ show: _ctx.hasActiveChildren(item2.route) }, "menu-item menu-accordion"],
                                    "data-kt-menu-sub": "accordion",
                                    "data-kt-menu-trigger": "click"
                                  }, [
                                    _createVNode("span", _hoisted_19, [
                                      _hoisted_20,
                                      _createVNode("span", _hoisted_21, _toDisplayString(_ctx.translate(item2.sectionTitle)), 1),
                                      _hoisted_22
                                    ]),
                                    _createVNode("div", {
                                      class: [{ show: _ctx.hasActiveChildren(item2.route) }, "menu-sub menu-sub-accordion"]
                                    }, [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(item2.sub, (item3, k) => {
                                        return (_openBlock(), _createBlock(_Fragment, { key: k }, [
                                          (item3.heading)
                                            ? (_openBlock(), _createBlock("div", _hoisted_23, [
                                                _createVNode(_component_router_link, {
                                                  to: item3.route
                                                }, {
                                                  default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                                                    _createVNode("a", {
                                                      class: ["menu-link", [
                                isActive && 'active',
                                isExactActive && 'active'
                              ]],
                                                      href: href,
                                                      onClick: navigate
                                                    }, [
                                                      _hoisted_24,
                                                      _createVNode("span", _hoisted_25, _toDisplayString(_ctx.translate(item3.heading)), 1)
                                                    ], 10, ["href", "onClick"])
                                                  ]),
                                                  _: 2
                                                }, 1032, ["to"])
                                              ]))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                      }), 128))
                                    ], 2)
                                  ], 2))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ], 2)
                      ], 2))
                    : _createCommentVNode("", true),
                  _hoisted_26
                ], 64))
              }), 128))
            ], 64))
          }), 128))
        : (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.MainMenuConfig, (item, i) => {
            return (_openBlock(), _createBlock(_Fragment, { key: i }, [
              (item.heading)
                ? (_openBlock(), _createBlock("div", _hoisted_27, [
                    _createVNode("div", _hoisted_28, [
                      _createVNode("span", _hoisted_29, _toDisplayString(_ctx.translate(item.heading)), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.pages, (menuItem, j) => {
                return (_openBlock(), _createBlock(_Fragment, { key: j }, [
                  (menuItem.heading)
                    ? (_openBlock(), _createBlock("div", _hoisted_30, [
                        _createVNode(_component_router_link, {
                          to: menuItem.route
                        }, {
                          default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                            _createVNode("a", {
                              class: [[isActive && 'active', isExactActive && 'active'], "menu-link"],
                              href: href,
                              onClick: navigate
                            }, [
                              (menuItem.svgIcon || menuItem.fontIcon)
                                ? (_openBlock(), _createBlock("span", _hoisted_31, [
                                    (_ctx.asideMenuIcons === 'font')
                                      ? (_openBlock(), _createBlock("i", {
                                          key: 0,
                                          class: [menuItem.fontIcon, "bi fs-3"]
                                        }, null, 2))
                                      : (_ctx.asideMenuIcons === 'svg')
                                        ? (_openBlock(), _createBlock("span", _hoisted_32, [
                                            _createVNode(_component_inline_svg, {
                                              src: menuItem.svgIcon
                                            }, null, 8, ["src"])
                                          ]))
                                        : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("span", _hoisted_33, _toDisplayString(_ctx.translate(menuItem.heading)), 1)
                            ], 10, ["href", "onClick"])
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    : _createCommentVNode("", true),
                  (menuItem.sectionTitle)
                    ? (_openBlock(), _createBlock("div", {
                        key: 1,
                        class: [{ show: _ctx.hasActiveChildren(menuItem.route) }, "menu-item menu-accordion"],
                        "data-kt-menu-sub": "accordion",
                        "data-kt-menu-trigger": "click"
                      }, [
                        _createVNode("span", _hoisted_34, [
                          (menuItem.svgIcon || menuItem.fontIcon)
                            ? (_openBlock(), _createBlock("span", _hoisted_35, [
                                (_ctx.asideMenuIcons === 'font')
                                  ? (_openBlock(), _createBlock("i", {
                                      key: 0,
                                      class: [menuItem.fontIcon, "bi fs-3"]
                                    }, null, 2))
                                  : (_ctx.asideMenuIcons === 'svg')
                                    ? (_openBlock(), _createBlock("span", _hoisted_36, [
                                        _createVNode(_component_inline_svg, {
                                          src: menuItem.svgIcon
                                        }, null, 8, ["src"])
                                      ]))
                                    : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode("span", _hoisted_37, _toDisplayString(_ctx.translate(menuItem.sectionTitle)), 1),
                          _hoisted_38
                        ]),
                        _createVNode("div", {
                          class: [{ show: _ctx.hasActiveChildren(menuItem.route) }, "menu-sub menu-sub-accordion"]
                        }, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(menuItem.sub, (item2, k) => {
                            return (_openBlock(), _createBlock(_Fragment, { key: k }, [
                              (item2.heading)
                                ? (_openBlock(), _createBlock("div", _hoisted_39, [
                                    _createVNode(_component_router_link, {
                                      to: item2.route
                                    }, {
                                      default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                                        _createVNode("a", {
                                          class: [[
                          isActive && 'active',
                          isExactActive && 'active'
                        ], "menu-link"],
                                          href: href,
                                          onClick: navigate
                                        }, [
                                          _hoisted_40,
                                          _createVNode("span", _hoisted_41, _toDisplayString(_ctx.translate(item2.heading)), 1)
                                        ], 10, ["href", "onClick"])
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]))
                                : _createCommentVNode("", true),
                              (item2.sectionTitle)
                                ? (_openBlock(), _createBlock("div", {
                                    key: 1,
                                    class: [{ show: _ctx.hasActiveChildren(item2.route) }, "menu-item menu-accordion"],
                                    "data-kt-menu-sub": "accordion",
                                    "data-kt-menu-trigger": "click"
                                  }, [
                                    _createVNode("span", _hoisted_42, [
                                      _hoisted_43,
                                      _createVNode("span", _hoisted_44, _toDisplayString(_ctx.translate(item2.sectionTitle)), 1),
                                      _hoisted_45
                                    ]),
                                    _createVNode("div", {
                                      class: [{ show: _ctx.hasActiveChildren(item2.route) }, "menu-sub menu-sub-accordion"]
                                    }, [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(item2.sub, (item3, k) => {
                                        return (_openBlock(), _createBlock(_Fragment, { key: k }, [
                                          (item3.heading)
                                            ? (_openBlock(), _createBlock("div", _hoisted_46, [
                                                _createVNode(_component_router_link, {
                                                  to: item3.route
                                                }, {
                                                  default: _withCtx(({ href, navigate, isActive, isExactActive }) => [
                                                    _createVNode("a", {
                                                      class: ["menu-link", [
                                isActive && 'active',
                                isExactActive && 'active'
                              ]],
                                                      href: href,
                                                      onClick: navigate
                                                    }, [
                                                      _hoisted_47,
                                                      _createVNode("span", _hoisted_48, _toDisplayString(_ctx.translate(item3.heading)), 1)
                                                    ], 10, ["href", "onClick"])
                                                  ]),
                                                  _: 2
                                                }, 1032, ["to"])
                                              ]))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                      }), 128))
                                    ], 2)
                                  ], 2))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ], 2)
                      ], 2))
                    : _createCommentVNode("", true),
                  _hoisted_49
                ], 64))
              }), 128))
            ], 64))
          }), 128))
    ])
  ], 512))
}